import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withIcon } from '../Icon';
export var DoorOpenOutlineSVG = function DoorOpenOutlineSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,28H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4h7V6H6V26h7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,3.514l9,2.077V26.409l-9,2.077V3.514M15.762,1.2A.753.753,0,0,0,15,2V30a.753.753,0,0,0,.762.8.935.935,0,0,0,.212-.025l11.052-2.55A1.321,1.321,0,0,0,28,27V5a1.321,1.321,0,0,0-.974-1.225L15.974,1.225a.935.935,0,0,0-.212-.025Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "16",
    r: "1"
  })));
};
DoorOpenOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
DoorOpenOutlineSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Open Door")
};
export default withIcon(DoorOpenOutlineSVG);